import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Error monitoring (votomoto-web). The DSN is public (ships in the bundle).
// Errors only at launch — no performance tracing, to stay well within the free tier.
Sentry.init({
  dsn: 'https://e0bf90e774d5652189c94c6d2cef0297@o4511580620455936.ingest.us.sentry.io/4511580640051200',
  environment: 'production',
  tracesSampleRate: 0,
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p style={{ padding: 24 }}>Something went wrong — please refresh.</p>}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
